/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyJob } from '../models/CompanyJob';
import type { Composite } from '../models/Composite';
import type { CompositeDataCutAdjustmentDetails } from '../models/CompositeDataCutAdjustmentDetails';
import type { DHSurveyJobDefinition } from '../models/DHSurveyJobDefinition';
import type { Paymarket } from '../models/Paymarket';
import type { SurveyBlob } from '../models/SurveyBlob';
import type { SurveyData } from '../models/SurveyData';
import type { SurveyDataCut } from '../models/SurveyDataCut';
import type { SurveyDataCutBlob } from '../models/SurveyDataCutBlob';
import type { SurveyDataCutPaymarketMappingDirection } from '../models/SurveyDataCutPaymarketMappingDirection';
import type { SurveyJobCompanyJobMappingStatus } from '../models/SurveyJobCompanyJobMappingStatus';
import type { SurveyJobDefinitionBlob } from '../models/SurveyJobDefinitionBlob';
import type { SurveyJobMappingReplacementAutoMatchingType } from '../models/SurveyJobMappingReplacementAutoMatchingType';
import type { SurveyJobSort } from '../models/SurveyJobSort';
import type { SurveyReplacement } from '../models/SurveyReplacement';
import type { SurveyReplacementCompositeDataCut } from '../models/SurveyReplacementCompositeDataCut';
import type { SurveyReplacementCompositeDataCutCreateRequest } from '../models/SurveyReplacementCompositeDataCutCreateRequest';
import type { SurveyReplacementCompositeDataCutSort } from '../models/SurveyReplacementCompositeDataCutSort';
import type { SurveyReplacementDataCutName } from '../models/SurveyReplacementDataCutName';
import type { SurveyReplacementDataCutPaymarketMapping } from '../models/SurveyReplacementDataCutPaymarketMapping';
import type { SurveyReplacementDataCutPaymarketMappingInfoRow } from '../models/SurveyReplacementDataCutPaymarketMappingInfoRow';
import type { SurveyReplacementDataSelectionType } from '../models/SurveyReplacementDataSelectionType';
import type { SurveyReplacementDecision } from '../models/SurveyReplacementDecision';
import type { SurveyReplacementJobMappingStatistic } from '../models/SurveyReplacementJobMappingStatistic';
import type { SurveyReplacementMappedFilter } from '../models/SurveyReplacementMappedFilter';
import type { SurveyReplacementRowStatus } from '../models/SurveyReplacementRowStatus';
import type { SurveyReplacementSummary } from '../models/SurveyReplacementSummary';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyReplacementService {

    /**
     * Get Survey Replacement
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacement({
        surveyId,
        planId,
    }: {
        /**
         * Survey Id
         */
        surveyId: string,
        /**
         * Plan Id
         */
        planId: number,
    }): CancelablePromise<{
        surveyReplacement: (SurveyReplacement | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement',
            query: {
                'surveyId': surveyId,
                'planId': planId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Replacement
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacement({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Apply New Survey
     * @returns any Success
     * @throws ApiError
     */
    public static applySurvey({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            /**
             * Deprecated single-source field. Normalized server-side into surveyIds. Either surveyId or surveyIds is required.
             */
            surveyId?: string;
            /**
             * Source surveys to replace with the target survey. Takes precedence over surveyId.
             */
            surveyIds?: Array<string>;
            targetSurveyId: string;
            stateUuid?: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/applySurvey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Get list of jobs for survey replacement
     * @returns any Success
     * @throws ApiError
     */
    public static searchSurveyJobs({
        requestBody,
    }: {
        requestBody: {
            /**
             * Survey ID
             */
            surveyId: string;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
            sort?: SurveyJobSort;
            search?: string;
            careerLevel?: Array<string>;
            globalLevel?: Array<string>;
            jobSubFamily?: Array<string>;
            jobFamily?: Array<string>;
            jobFocus?: Array<string>;
            jobType?: string | null;
            module?: Array<string>;
            purchasedOnly?: boolean;
        },
    }): CancelablePromise<{
        rows: Array<DHSurveyJobDefinition>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/searchSurveyJobs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Publish Survey Replacement
     * @returns any Success
     * @throws ApiError
     */
    public static publishSurveyReplacement({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/publish',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Get Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementJobMapping({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            ids?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobCategory?: Array<number>;
            jobLevel?: Array<number>;
            statuses?: Array<SurveyReplacementDecision>;
            rowStatus?: Array<SurveyReplacementRowStatus>;
            autoMatchingType?: SurveyJobMappingReplacementAutoMatchingType;
            mapped?: SurveyReplacementMappedFilter;
            search?: string;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<CompanyJob>;
        jobDefinitionBlobs?: Record<string, (SurveyJobDefinitionBlob | Record<string, any>)>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/jobMapping',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Symmary
     * @returns SurveyReplacementSummary Success
     * @throws ApiError
     */
    public static getSurveyReplacementSummary({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<SurveyReplacementSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/summary',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Summary Report Url
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementSummaryReportUrl({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/summaryReportUrl',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Actualize Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static actualizeSurveyReplacementJobMapping({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/jobMapping/actualize',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement Job Mapping Statistic
     * @returns SurveyReplacementJobMappingStatistic Success
     * @throws ApiError
     */
    public static getSurveyReplacementJobMappingStatistic({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<SurveyReplacementJobMappingStatistic> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/jobMapping/statistic',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyReplacementJobMapping({
        replacementId,
        jobMappingId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Job Mapping Id
         */
        jobMappingId: number,
        requestBody: {
            targetSurveyJobDefinitionId?: string | null;
            adjustment?: number | null;
            status?: SurveyJobCompanyJobMappingStatus;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveyReplacement/{replacementId}/jobMapping/{jobMappingId}',
            path: {
                'replacementId': replacementId,
                'jobMappingId': jobMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Delete Survey Replacement Job Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacementJobMapping({
        replacementId,
        jobMappingId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Job Mapping Id
         */
        jobMappingId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/jobMapping/{jobMappingId}',
            path: {
                'replacementId': replacementId,
                'jobMappingId': jobMappingId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Survey Replacement Job Mapping Next Step
     * @returns any Success
     * @throws ApiError
     */
    public static surveyReplacementJobMappingNext({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            stateUuid: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/jobMapping/next',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Survey Replacement Data Cut Paymarket Mapping Next Step
     * @returns any Success
     * @throws ApiError
     */
    public static surveyReplacementDataCutPaymarketMappingNext({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            stateUuid: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/next',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Actualize Survey Replacement DataCut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static actualizeSurveyReplacementDataCutPaymarketMapping({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/actualize',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement DataCut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            ids?: Array<number>;
            paymarketId?: number;
            statuses?: Array<SurveyReplacementDecision>;
            mapped?: SurveyReplacementMappedFilter;
            search?: string;
            sort?: Record<string, any>;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<SurveyReplacementDataCutPaymarketMappingInfoRow>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/list',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Create Survey Replacement DataCut Paymarket Mapping
     * @returns SurveyReplacementDataCutPaymarketMapping Success
     * @throws ApiError
     */
    public static createSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            paymarketId: number;
            targetSurveyDataCutId: string;
        },
    }): CancelablePromise<SurveyReplacementDataCutPaymarketMapping> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/create',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get paymarkets for replaced cuts
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutPaymarkets({
        replacementId,
        mapped,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Return only paymarkets that have replaced cuts in a target survey
         */
        mapped?: boolean,
    }): CancelablePromise<{
        rows: Array<Paymarket>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/paymarket',
            path: {
                'replacementId': replacementId,
            },
            query: {
                'mapped': mapped,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get paymarkets for replaced cuts
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementDataCutMappingsSearch({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            /**
             * Paymarket ID
             */
            paymarketId: number;
            /**
             * Page number
             */
            offset?: number;
            /**
             * Max items per page
             */
            limit?: number;
        },
    }): CancelablePromise<{
        rows: Array<SurveyReplacementDataCutPaymarketMapping>;
        surveyDataCuts?: Record<string, (SurveyDataCut | Record<string, any>)>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/search',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Target Survey Data Cut for Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateTargetSurveyDataCut({
        replacementId,
        dataCutPaymarketMappingId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Data Cutp Paymarket Mapping Id
         */
        dataCutPaymarketMappingId: number,
        requestBody: {
            targetSurveyDataCutId: string | null;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Update Survey Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        dataCutPaymarketMappingId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Data Cutp Paymarket Mapping Id
         */
        dataCutPaymarketMappingId: number,
        requestBody: {
            adjustment?: number;
            weight?: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Delete Survey Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacementDataCutPaymarketMapping({
        replacementId,
        dataCutPaymarketMappingId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Data Cutp Paymarket Mapping Id
         */
        dataCutPaymarketMappingId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * Change the order of a Survey Replacement Data Cut Paymarket Mapping
     * @returns any Success
     * @throws ApiError
     */
    public static changeOrderReplacementDataCutPaymarketMapping({
        replacementId,
        dataCutPaymarketMappingId,
        requestBody,
    }: {
        /**
         * The ID of the Survey Replacement.
         */
        replacementId: number,
        /**
         * The ID of the Survey Replacement Data Cut Paymarket Mapping to reorder.
         */
        dataCutPaymarketMappingId: number,
        requestBody: {
            direction: SurveyDataCutPaymarketMappingDirection;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/dataCutPaymarketMapping/{dataCutPaymarketMappingId}/position',
            path: {
                'replacementId': replacementId,
                'dataCutPaymarketMappingId': dataCutPaymarketMappingId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Enable Survey Replacement Composite Data Cut
     * @returns SurveyReplacementCompositeDataCut Success
     * @throws ApiError
     */
    public static createSurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: SurveyReplacementCompositeDataCutCreateRequest,
    }): CancelablePromise<Array<SurveyReplacementCompositeDataCut>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Disable Survey Replacement Composite Data Cut
     * @returns any Record deleted successfully. No content returned.
     * @throws ApiError
     */
    public static removeSurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            compositeId: number;
            targetSurveyDataId: string;
        },
    }): CancelablePromise<{
        ids?: Array<number>;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/compositeDataCut',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Survey Replacement CompositeDataCut
     * @returns any Success
     * @throws ApiError
     */
    public static getSurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            paymarketId: number;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            compositeIds?: Array<number>;
            sort?: SurveyReplacementCompositeDataCutSort;
            limit?: number;
            offset?: number;
        },
    }): CancelablePromise<{
        rows: Array<Composite>;
        surveyReplacementDataCutPaymarketMappings: Array<SurveyReplacementDataCutPaymarketMapping>;
        targetSurveyBlob: SurveyBlob;
        surveyJobDefinitionBlobs: Record<string, (SurveyJobDefinitionBlob | Record<string, any>)>;
        surveyDataCutBlobs: Record<string, (SurveyDataCutBlob | Record<string, any>)>;
        surveyDataBlobs: Array<SurveyData>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/list',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Actualize Survey Replacement CompositeDataCut
     * @returns any Success
     * @throws ApiError
     */
    public static actualizeSurveyReplacementCompositeDataCut({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<{
        surveyReplacement: (SurveyReplacement | Record<string, any> | null);
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/actualize',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Apply Policy on Survey Replacement CompositeDataCut
     * @returns any Success
     * @throws ApiError
     */
    public static applyCutSelectionPolicySurveyReplacementCompositeDataCut({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            cutSelectionPolicyType: SurveyReplacementDataSelectionType;
            pricingPolicyId?: number | null;
            paymarketId: number;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<{
        surveyReplacement: SurveyReplacement;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/applyCutSelectionPolicy',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Survey Replacement Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyReplacementCompositeDataCut({
        replacementId,
        compositeDataCutId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Composite Data Cut Id
         */
        compositeDataCutId: number,
        requestBody: {
            adjustment?: number;
            weight?: number;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/{compositeDataCutId}',
            path: {
                'replacementId': replacementId,
                'compositeDataCutId': compositeDataCutId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

    /**
     * get adjustment and weight details
     * @returns CompositeDataCutAdjustmentDetails Success
     * @throws ApiError
     */
    public static getSurveyReplacementCompositeDataCutAdjustmentDetails({
        replacementId,
        compositeDataCutId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        /**
         * Survey Replacement Composite Data Cut Id
         */
        compositeDataCutId: number,
    }): CancelablePromise<CompositeDataCutAdjustmentDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/compositeDataCut/{compositeDataCutId}/adjustment',
            path: {
                'replacementId': replacementId,
                'compositeDataCutId': compositeDataCutId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Upsert Survey Replacement Data Cut Name
     * @returns SurveyReplacementDataCutName Success
     * @throws ApiError
     */
    public static upsertSurveyReplacementDataCutName({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            targetSurveyDataCutId: string;
            name: string;
        },
    }): CancelablePromise<SurveyReplacementDataCutName> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/surveyReplacement/{replacementId}/surveyDataCutName',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Survey Replacement Data Cut Name
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyReplacementDataCutName({
        replacementId,
        requestBody,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
        requestBody: {
            targetSurveyDataCutId: string;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/surveyReplacement/{replacementId}/surveyDataCutName',
            path: {
                'replacementId': replacementId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Survey Replacement Summary Report
     * @returns string Success
     * @throws ApiError
     */
    public static generateSurveyReplacementSummaryReport({
        replacementId,
    }: {
        /**
         * Survey Replacement Id
         */
        replacementId: number,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyReplacement/{replacementId}/report/summary',
            path: {
                'replacementId': replacementId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                409: `Request conflict with the current state of the target resource`,
            },
        });
    }

}
